import useHicetnuncContext from '~/contexts/Hicetnunc/useHicetnuncContext';

const useCurrentUserAddress = (): string => {
  const { acc } = useHicetnuncContext();
  return acc?.address;
};

export default useCurrentUserAddress;
